import classNames from 'classnames';
import React from 'react';
import { useCurationReview } from './state/CurationReviewContext';

const styles = require('./PhaseStepper.module.scss');

interface Phase {
  label: string;
  state: 'done' | 'active' | 'pending';
}

// Sidebar stepper naming the two curation phases and the final decision.
export default function PhaseStepper() {
  const { state } = useCurationReview();

  const phases: Phase[] = [
    {
      label: 'Eligibility checks',
      state: state.gateConfirmed ? 'done' : 'active',
    },
    {
      label: 'AI match & review',
      state: state.aiStatus === 'loaded' ? 'done' : state.gateConfirmed ? 'active' : 'pending',
    },
    {
      label: 'Decision',
      state: state.submitted ? 'done' : state.aiStatus === 'loaded' ? 'active' : 'pending',
    },
  ];

  return (
    <ol aria-label="Curation phases" className={styles['ui-phase-stepper']}>
      {phases.map((phase) => (
        <li
          className={classNames(
            styles['ui-phase-stepper__phase'],
            styles[`ui-phase-stepper__phase--${phase.state}`],
          )}
          key={phase.label}
        >
          <span aria-hidden className={styles['ui-phase-stepper__dot']} />
          {phase.label}
        </li>
      ))}
    </ol>
  );
}
